<section class="rq-card" aria-label="Booking requests">
  <header class="rq-head">
    <h2 class="rq-title">Booking requests</h2>
    @if (!loading && !failed) {
      <span class="rq-count" data-testid="request-count">{{ requests.length }} to answer</span>
    }
    <span class="rq-sub">All dates · the soonest deadline first</span>
  </header>

  @if (loading) {
    <p class="rq-state">Loading requests…</p>
  } @else if (failed) {
    <p class="rq-state" role="alert">
      Requests couldn't be loaded.
      <button type="button" class="rq-link" (click)="reload()">Try again</button>
    </p>
  } @else if (!requests.length) {
    <div
      class="d-flex flex-column align-items-center justify-content-center common-empty-container"
      data-testid="requests-empty"
    >
      <p class="common-empty-header">No requests waiting</p>
      <p class="common-empty-sub-text">
        New booking requests appear here, with how long you have to answer each one.
      </p>
    </div>
  } @else {
    <div class="rq-scroll">
      <table class="rq-table">
        <thead>
          <tr>
            <th scope="col">Answer by</th>
            <th scope="col">Guest</th>
            <th scope="col">Party</th>
            <th scope="col">Date &amp; time</th>
            <th scope="col">Via</th>
            <th scope="col" class="rq-col-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (r of requests; track r.reservationId) {
            <tr (click)="open.emit(r)" data-testid="request-row">
              <td>
                @if (deadlineOf(r); as deadline) {
                  <span
                    class="rq-deadline"
                    [class.rq-deadline--urgent]="urgent(r)"
                    [matTooltip]="deadlineAt(r)"
                    data-testid="request-deadline"
                    ><i class="bx bx-timer" aria-hidden="true"></i> {{ deadline }}</span
                  >
                } @else {
                  <span class="rq-muted">—</span>
                }
              </td>
              <td>
                <div class="rq-guest">
                  <span class="rq-guest-name">{{ r.guest.name }}</span>
                  <span class="rq-guest-meta">{{ contactOf(r) }}</span>
                </div>
              </td>
              <td class="rq-nowrap">
                <i class="bx bx-group" aria-hidden="true"></i> {{ r.partySize }}
              </td>
              <td class="rq-nowrap">{{ whenOf(r) }}</td>
              <td>
                <span class="rq-channel" [matTooltip]="channelLabels[r.channel]"
                  ><i class="bx" [ngClass]="channelIcon(r.channel)" aria-hidden="true"></i
                  ><span class="visually-hidden">{{ channelLabels[r.channel] }}</span></span
                >
              </td>
              <td class="rq-col-actions" (click)="$event.stopPropagation()">
                <div class="rq-actions">
                  <button
                    type="button"
                    class="rq-btn rq-btn--ok"
                    (click)="accept.emit(r)"
                    data-testid="request-accept"
                  >
                    <i class="bx bx-check" aria-hidden="true"></i> Accept
                  </button>
                  <button
                    type="button"
                    class="rq-btn"
                    (click)="decline.emit(r)"
                    data-testid="request-decline"
                  >
                    <i class="bx bx-x-circle" aria-hidden="true"></i> Decline
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</section>
